/* tslint:disable */
/* eslint-disable */
/**
 * DexIt
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AuditHistoryRequestModel } from '../Models';
// @ts-ignore
import { ReportsResponseModel } from '../Models';
/**
 * MatomoReportsApi - axios parameter creator
 * @export
 */
export const MatomoReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AuditHistoryRequestModel} auditHistoryRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVisitDetails: async (auditHistoryRequestModel: AuditHistoryRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditHistoryRequestModel' is not null or undefined
            assertParamExists('reportVisitDetails', 'auditHistoryRequestModel', auditHistoryRequestModel)
            const localVarPath = `/api/v1/matomoReports/visitDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auditHistoryRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatomoReportsApi - functional programming interface
 * @export
 */
export const MatomoReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatomoReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AuditHistoryRequestModel} auditHistoryRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVisitDetails(auditHistoryRequestModel: AuditHistoryRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportsResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVisitDetails(auditHistoryRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatomoReportsApi.reportVisitDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatomoReportsApi - factory interface
 * @export
 */
export const MatomoReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatomoReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditHistoryRequestModel} auditHistoryRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVisitDetails(auditHistoryRequestModel: AuditHistoryRequestModel, options?: any): AxiosPromise<ReportsResponseModel> {
            return localVarFp.reportVisitDetails(auditHistoryRequestModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatomoReportsApi - interface
 * @export
 * @interface MatomoReportsApi
 */
export interface MatomoReportsApiInterface {
    /**
     * 
     * @param {AuditHistoryRequestModel} auditHistoryRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatomoReportsApiInterface
     */
    reportVisitDetails(auditHistoryRequestModel: AuditHistoryRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<ReportsResponseModel>;

}

/**
 * MatomoReportsApi - object-oriented interface
 * @export
 * @class MatomoReportsApi
 * @extends {BaseAPI}
 */
export class MatomoReportsApi extends BaseAPI implements MatomoReportsApiInterface {
    /**
     * 
     * @param {AuditHistoryRequestModel} auditHistoryRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatomoReportsApi
     */
    public reportVisitDetails(auditHistoryRequestModel: AuditHistoryRequestModel, options?: RawAxiosRequestConfig) {
        return MatomoReportsApiFp(this.configuration).reportVisitDetails(auditHistoryRequestModel, options).then((request) => request(this.axios, this.basePath));
    }
}

